import React, { Fragment } from 'react'
import './Banner.css'
import { Typography, Button } from '@mui/material'
import { useSelector } from 'react-redux'
import { IBannerReducer, IReducer } from '../interface'
import { ConfigContext } from '../App'

interface IBannerProps {
  data: IBannerReducer
}

export default function Banner(props: IBannerProps) {
  const { data } = props

  const language = useSelector((state: IReducer) => state.changeLanguage)
  const configValue = React.useContext(ConfigContext)

  return (
    <Fragment>
      <div
        className='banner'
        style={{
          background: data.background && `url(${data.background}) no-repeat center center `,
          backgroundSize: 'cover',
          marginTop: 0,
          backgroundColor: data.backgroundColor,
          cursor: 'default'
        }}
        onClick={() => {
          window.innerWidth < 768 && data.link && window.open(data.link)
        }}
      >
        <div
          data-gtm-component='banner'
          data-gtm-click-section='Banner'
          data-gtm-click-subsection1={data.title}
          className='booth-container'
        >
          <div className={data.link ? 'booth-text' : 'booth-no-button'}>
            <Typography variant={data.titleOptions?.variant} sx={{ color: data.titleOptions?.color }}>
              {language.lang === 'en' || !data.titleTranslations || !data.titleTranslations[language.lang]
                ? data.title
                : data.titleTranslations[language.lang]}
            </Typography>
            <Typography variant={data.contentOptions?.variant} sx={{ color: data.contentOptions?.color }}>
              {language.lang === 'en' || !data.contentTranslations || !data.contentTranslations[language.lang]
                ? data.contentText
                : data.contentTranslations[language.lang]}
            </Typography>
          </div>
          {configValue.isSmallScreen === false && data.link && (
            <Button
              data-gtm-click-subsection2='primary-cta'
              variant={data.buttonOptions?.variant}
              color={data.buttonOptions.color}
              size='small'
              href={data.link}
              target='_blank'
              rel='noopener noreferrer'
            >
              {language.lang === 'en' ||
              !data.buttonOptions?.buttonTranslations ||
              !data.buttonOptions?.buttonTranslations[language.lang]
                ? data.buttonOptions?.text
                : data.buttonOptions?.buttonTranslations[language.lang]}
            </Button>
          )}
        </div>
      </div>
    </Fragment>
  )
}
